export enum CollectionType {
    UNSUPPORTED = 'UNSUPPORTED',
    SUBSCRIPTIONS = 'SUBSCRIPTIONS',
    OVATIC = 'OVATIC'
}
